<template>
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M45.0027 23.5019C45.0027 23.1041 44.8446 22.7225 44.5633 22.4412C44.282 22.1599 43.9005 22.0019 43.5027 22.0019H8.12368L17.5647 12.5639C17.8463 12.2822 18.0046 11.9002 18.0046 11.5019C18.0046 11.1036 17.8463 10.7215 17.5647 10.4399C17.283 10.1582 16.901 10 16.5027 10C16.1044 10 15.7223 10.1582 15.4407 10.4399L3.44068 22.4399C3.30099 22.5792 3.19016 22.7448 3.11454 22.927C3.03892 23.1092 3 23.3046 3 23.5019C3 23.6992 3.03892 23.8946 3.11454 24.0768C3.19016 24.259 3.30099 24.4246 3.44068 24.5639L15.4407 36.5639C15.5801 36.7034 15.7457 36.814 15.9279 36.8895C16.1101 36.9649 16.3054 37.0038 16.5027 37.0038C16.901 37.0038 17.283 36.8455 17.5647 36.5639C17.8463 36.2822 18.0046 35.9002 18.0046 35.5019C18.0046 35.1036 17.8463 34.7215 17.5647 34.4399L8.12368 25.0019H43.5027C43.9005 25.0019 44.282 24.8439 44.5633 24.5625C44.8446 24.2812 45.0027 23.8997 45.0027 23.5019Z" fill="currentColor"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGArrowTooltipLeft',
};
</script>

<style scoped lang="scss">

</style>
